import { forwardRef } from 'react';

const WorkItem = forwardRef(({
    imgURL,
    title,
    client,
    url,
    onUrlClick,
    tags = [],
    categorys = [],
    featured,
    award
}, ref) => {
    return (
        <div
            className={`work-item-box ${featured === "large" ? 'featured' : featured === "small" ? 'featured-small' : ''}`}
            data-category={categorys.join(' ')} // 카테고리 배열을 공백 구분 문자열로
            ref={ref} // ref 전달
        >
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    onUrlClick(url);
                }}
            >
                <div className="work-item-img-container">
                    <img src={imgURL} alt="" />
                    <div
                        className='work-item-award-tag-if'
                        style={{
                            display: award === "iF Gold" ? 'block' : 'none'
                        }}
                    >
                        iF Gold
                    </div>
                    <div
                        className='work-item-award-tag-red'
                        style={{
                            display: award === "RedDot" ? 'block' : 'none'
                        }}
                    >
                        RedDot
                    </div>
                </div>
                <div className="work-item-client">{client}</div>
                <div className="work-item-title">{title}</div>
                <div className="work-tag-container">
                    {/* 기존 tags 배열을 그대로 사용해 태그 표시 */}
                    {tags.map((tag, index) => (
                        <div className="work-tag" key={index}>{tag}</div>
                    ))}
                </div>
            </a>
        </div>
    );
});

export default WorkItem;